import React from 'react'
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon } from 'react-share';

const SocialShare = (props) => {
  return (
    <div className="mr-1 mt-1 flex gap-1 self-start">
        <FacebookShareButton
            url={props.url}
            quote='Okapi, Casa Nido en Oviedo. Asturias.'>
            <FacebookIcon style={{ opacity: '0.8'}} size={35} />
        </FacebookShareButton>
        <TwitterShareButton
            url={props.url}
            title='Okapi, Casa Nido en Oviedo. Asturias.'>
            <TwitterIcon style={{ opacity: '0.8'}} size={35} />
        </TwitterShareButton>
    </div>
  )
}

export default SocialShare;
